var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_650_14604)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6462 15.3537C11.2164 14.2841 10.9969 13.1415 11 11.9887C11 7.16625 14.885 3.15875 19.705 3.005C20.9363 2.96395 22.1629 3.17614 23.3089 3.62841C24.4548 4.08069 25.4957 4.76342 26.3671 5.63433C27.2385 6.50523 27.9217 7.54576 28.3746 8.69147C28.8275 9.83719 29.0404 11.0637 29 12.295C28.8413 17.115 24.8337 21 20.0112 21C18.8585 21.0031 17.7159 20.7836 16.6462 20.3537L15 22H12V25H9V28H5C4.73478 28 4.48043 27.8946 4.29289 27.7071C4.10536 27.5196 4 27.2652 4 27V23.4137C4.00012 23.1489 4.10532 22.8949 4.2925 22.7075L11.6462 15.3537Z",
    stroke: "#C9B8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 11C23.3284 11 24 10.3284 24 9.5C24 8.67157 23.3284 8 22.5 8C21.6716 8 21 8.67157 21 9.5C21 10.3284 21.6716 11 22.5 11Z",
    fill: "#C9B8FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_650_14604"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/Key.28f799535f6beac852b138f9da641c64.svg";
export { ForwardRef as ReactComponent };